// extracted by mini-css-extract-plugin
export default {"scimToken":"SCIMTab-module__scimToken--abxPR","regenerateToken":"SCIMTab-module__regenerateToken--WA1-r"};